import {Observer} from './observer.min';
import {Slideshow} from "./slideshow";

export default class HeroSlider {
	constructor(el = null) {
		if (!el) return;
		this.heroSection = el;
		this.slideshow = new Slideshow(this.heroSection);

		this.thumbsWrapper = document.querySelector(`.slider-thumbs-wrapper[data-for="${this.heroSection.getAttribute('id')}"]`);

		this.thumbsLinks = this.thumbsWrapper && Array.from(this.thumbsWrapper.querySelectorAll('a'));

		this.thumbsLinks.map(link => {
			link.addEventListener('click', this.onLinkClick.bind(this), false);
		});

		window.addEventListener('heroslider.animation.started', (ev) => {
			this.thumbsLinks.map(el => el.classList.remove('is-active'));
			this.thumbsLinks[ev.detail].classList.add('is-active');
		});

		Observer.create({
			target: this.heroSection,
			type: 'wheel,touch,pointer',
			onRight: () => this.slideshow.prev(),
			onLeft: () => this.slideshow.next(),
			// invert the mouse wheel delta
			wheelSpeed: -1,
			tolerance: 30,
		});
	}

	onLinkClick(event) {
		event.preventDefault();
		const idx = this.thumbsLinks.indexOf(event.currentTarget);
		this.slideshow.goto(idx);
	}
}
